type ContractorNameFields = {
  businessName?: string | null
  firstName: string
  middleName?: string | null
  lastName: string
  suffix?: string | null
}

type ContractorAddressFields = {
  address1: string
  address2?: string | null
  city: string
  state: string
  zipCode: string
}

export const getMaContractorDisplayName = (result: ContractorNameFields): string => {
  if (result.businessName) {
    return result.businessName
  }
  return [result.firstName, result.middleName, result.lastName, result.suffix]
    .filter(Boolean)
    .join(' ')
}

export const getMaContractorFormattedAddress = (result: ContractorAddressFields): string => {
  return [result.address1, result.address2, result.city, result.state, result.zipCode]
    .filter(Boolean)
    .join(', ')
}
